import React, { useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import { Button, Card, CardBody } from "reactstrap"

import TableContainer from "../../components/Common/TableContainer"
import { Link } from "react-router-dom"

const AlumnosSegmentados = ({ columns, dataAlumnos, isLoading }) => {
  //
  const [modal1, setModal1] = useState(false)

  const toggleViewModal = () => setModal1(!modal1)

  return (
    <React.Fragment>
      {/* <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} /> */}
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Alumnos Segmentados</div>

          <TableContainer
            columns={columns}
            data={dataAlumnos}
            isGlobalFilter={true}
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light"
            isPagination={false}
            isLoading={isLoading}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

AlumnosSegmentados.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
}

export default withRouter(AlumnosSegmentados)
